import { POST, GET } from '@/shared/api/requests';
import type {
  PasswordResetRequest,
  PasswordResetResponse,
  PasswordStatusResponse,
  PasswordResetWithTokenRequest,
  PasswordResetWithTokenResponse,
  PasswordResetRequestPayload,
  PasswordResetRequestResponse,
} from '../types';

/**
 * Reset user password (when expired or user-initiated)
 * @param data - Password reset form data
 * @returns Promise with reset response
 */
export const resetPassword = async (
  data: PasswordResetRequest
): Promise<PasswordResetResponse> => {
  const response = await POST<PasswordResetRequest>('/users/auth/reset-password/', data);
  return response.data as PasswordResetResponse;
};

/**
 * Get password status information
 * @returns Promise with password status
 */
export const getPasswordStatus = async (): Promise<PasswordStatusResponse> => {
  const response = await GET<void>('/users/auth/reset-password/');
  return response.data as PasswordStatusResponse;
};

/**
 * Request a password reset email (forgot password)
 * @param data - Email address
 * @returns Promise with response message
 */
export const requestPasswordReset = async (
  data: PasswordResetRequestPayload
): Promise<PasswordResetRequestResponse> => {
  const response = await POST<PasswordResetRequestPayload>(
    '/users/auth/reset-password-request/',
    data
  );
  return response.data as PasswordResetRequestResponse;
};

/**
 * Reset password using token from email link (unauthenticated)
 * @param data - Password reset with token data
 * @returns Promise with reset response
 */
export const resetPasswordWithToken = async (
  data: PasswordResetWithTokenRequest
): Promise<PasswordResetWithTokenResponse> => {
  const response = await POST<PasswordResetWithTokenRequest>(
    '/users/auth/reset-password-confirm/',
    data
  );
  return response.data as PasswordResetWithTokenResponse;
};

